import * as React from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { InputProps } from "../../interfaces/props/InputProps";
import { logger } from "../../../../utilities/logger";
import { SharePointMetadataBooleans } from "../../config/sharepointConstants";

export const HyperLink: React.FunctionComponent<InputProps> = ({
  displayName,
  inputValue,
  error,
  updateInputValidationStatus,
  inputValidator,
  isRequired
}: InputProps) => {

  const isFirstRun = React.useRef(true);
  React.useEffect(() => {
    try {
      if (isFirstRun.current) {
        isFirstRun.current = false;
        return;
      }
      updateInputValidationStatus(inputValidator.validate(inputValue?.value));
    } catch (e) {
      logger(e, "hyperlink.tsx (useEffect)")
    }
  }, [inputValue?.updatedFromDataSourceToggle]);

  const handleHyperLinkFieldOnchange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue: string): void => {
    updateInputValidationStatus(inputValidator.validate(newValue));
  };

  return (
    <>
      <TextField
        label={displayName}
        disabled={inputValue?.xml?.ReadOnly === SharePointMetadataBooleans.true}
        type="text"
        value={inputValue?.value ?? ""}
        onChange={handleHyperLinkFieldOnchange}
        required={isRequired()}
        errorMessage={error}
        className="xb-sp-input"
      />
    </>
  );
};

export default HyperLink;
